/* Aveline theme, shared interactions (ported from the Aveline design handoff, wired to Shopify's Ajax Cart API) */
(function () {
  'use strict';

  var cfg = window.Aveline || {};
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = cfg.rootUrl || '/';
  if (root.slice(-1) !== '/') root += '/';

  /* ---------- Money (uses the store's money format) ---------- */
  function fmt(cents) {
    var format = cfg.moneyFormat || '${{amount}}';
    var value = (Number(cents) || 0) / 100;
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var str;
    switch (key) {
      case 'amount_no_decimals': str = Math.round(value).toLocaleString('en-US'); break;
      case 'amount_with_comma_separator': str = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      case 'amount_no_decimals_with_comma_separator': str = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      case 'amount_with_apostrophe_separator': str = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'"); break;
      default: str = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, str);
  }
  window.AvelineMoney = fmt;

  function decodeEntities(str) {
    if (typeof str !== 'string' || str.indexOf('&') === -1) return str;
    var ta = document.createElement('textarea');
    ta.innerHTML = str;
    return ta.value;
  }

  /* Drawers ship with an inline visibility guard so they can never paint
     before this script runs (the theme editor breaks position:fixed). */
  document.querySelectorAll('[data-mobile-menu],[data-cart-drawer]').forEach(function (el) { el.style.visibility = ''; });

  /* Judge.me: any [data-write-review] button scrolls to the widget and opens its form;
     ?open_review=1 on a product URL does the same on arrival (used by Track Order links). */
  function openReviewForm() {
    var widget = document.getElementById('judgeme_product_reviews');
    if (widget) { widget.hidden = false; widget.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    var tries = 0;
    (function attempt() {
      var link = document.querySelector('.jdgm-write-rev-link');
      if (link) { link.click(); return; }
      if (++tries < 24) setTimeout(attempt, 250);
    })();
  }
  /* Sort pills above the Judge.me widget: built from the widget's own sort
     dropdown once it renders, so labels and values always match Judge.me. */
  (function () {
    var row = document.querySelector('[data-jdgm-sort-pills]');
    var host = document.querySelector('[data-jdgm-widget-host]');
    if (!row || !host) return;
    var tries = 0;
    (function wait() {
      var dropdown = host.querySelector('select.jdgm-sort-dropdown, select[class*="sort"]');
      if (!dropdown) { if (++tries < 60) setTimeout(wait, 500); return; }
      if (Array.prototype.some.call(dropdown.options, function (o) { return o.value === 'pictures-first'; })) {
        dropdown.value = 'pictures-first';
        dropdown.dispatchEvent(new Event('change', { bubbles: true }));
      }
      row.innerHTML = '';
      Array.prototype.forEach.call(dropdown.options, function (opt) {
        var label = (opt.textContent || '').trim();
        if (!label) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pill' + (opt.value === dropdown.value ? ' selected' : '');
        b.textContent = label;
        b.setAttribute('aria-pressed', opt.value === dropdown.value ? 'true' : 'false');
        b.addEventListener('click', function () {
          dropdown.value = opt.value;
          dropdown.dispatchEvent(new Event('change', { bubbles: true }));
          Array.prototype.forEach.call(row.children, function (c) { c.classList.remove('selected'); c.setAttribute('aria-pressed', 'false'); });
          b.classList.add('selected');
          b.setAttribute('aria-pressed', 'true');
        });
        row.appendChild(b);
      });
      if (row.children.length) row.hidden = false;
    })();
  })();

  /* Big average-rating badge in the reviews summary, built from the widget's
     own data attributes. Re-applied if Judge.me re-renders (guarded so the
     observer never loops: it only acts when the badge is missing). */
  (function () {
    var section = document.getElementById('reviews');
    if (!section) return;
    /* Judge.me widget v3 colours everything through --jdgm-* custom properties and
       writes the merchant's palette at runtime. Setting the variables inline with
       'important' on every widget root wins over any injection, so the widget
       takes the brand gold no matter how the app applies its own colour. */
    var brandVars = null;
    function brandJudgeme() {
      if (!brandVars) {
        var cs = getComputedStyle(document.documentElement);
        var gold = (cs.getPropertyValue('--gold') || '').trim() || '#C4A867';
        var goldDeep = (cs.getPropertyValue('--gold-deep') || '').trim() || '#B8955B';
        var noir = (cs.getPropertyValue('--noir') || '').trim() || '#2C2A22';
        brandVars = {
          '--jdgm-primary-color': gold, '--jdgm-star-color': gold, '--jdgm-snippet-star-color': gold,
          '--jdgm-secondary-color': goldDeep, '--jdgm-write-review-bg-color': noir,
          '--jdgm-write-review-text-color': '#ffffff', '--jdgm-reviewer-name-color': noir,
          '--jdgm-paginate-color': noir, '--jdgm-border-radius': '6px'
        };
      }
      /* Re-asserted on every pass (Judge.me may rewrite its inline colours after
         we run). Compare before writing so an already-correct value is left
         alone: that keeps the style-attribute observer below from re-firing on
         our own writes. */
      section.querySelectorAll('.jdgm-widget, .jdgm-rev-widg, .jdgm-preview-badge').forEach(function (el) {
        Object.keys(brandVars).forEach(function (k) {
          if (el.style.getPropertyValue(k) !== brandVars[k] || el.style.getPropertyPriority(k) !== 'important') {
            el.style.setProperty(k, brandVars[k], 'important');
          }
        });
      });
    }
    function applyBadge() {
      brandJudgeme();
      var widg = section.querySelector('.jdgm-rev-widg[data-average-rating]');
      if (!widg) return false;
      /* Hide empty seller-reply blocks (Judge.me leaves the container in place;
         :empty in CSS misses whitespace-only nodes). */
      section.querySelectorAll('.jdgm-rev__reply').forEach(function (r) {
        if (!r.textContent.trim() && !r.querySelector('img')) r.style.display = 'none';
      });
      var summary = widg.querySelector('.jdgm-rev-widg__summary');
      if (!summary || summary.querySelector('.av-jdgm-avg')) return true;
      var avg = parseFloat(widg.getAttribute('data-average-rating'));
      if (!avg) return true;
      var num = (Math.round(avg * 10) / 10).toString();
      var badge = document.createElement('div');
      badge.className = 'av-jdgm-avg';
      badge.setAttribute('aria-hidden', 'true');
      badge.innerHTML = '<span class="av-jdgm-avg__num">' + esc(num) + '</span><span class="av-jdgm-avg__of">/ 5</span>';
      summary.insertBefore(badge, summary.firstChild);
      return true;
    }
    var tries = 0;
    (function wait() { if (applyBadge()) return; if (++tries < 60) setTimeout(wait, 500); })();
    if ('MutationObserver' in window) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(applyBadge, 150); }).observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    }
  })();

  (function () {
    var section = document.getElementById('reviews');
    if (!section) return;
    function showReviewDetails() {
      section.querySelectorAll('.jdgm-rev:not([data-av-review-details])').forEach(function (review) {
        var content = review.querySelector('.jdgm-rev__content');
        if (!content) return;
        var details = [];
        var timestamp = review.querySelector('time.jdgm-rev__timestamp');
        if (timestamp && timestamp.getAttribute('datetime')) {
          var date = new Date(timestamp.getAttribute('datetime'));
          if (!isNaN(date.getTime())) details.push('Reviewed ' + date.toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }));
        }
        var location = review.querySelector('.jdgm-rev__location');
        if (location && location.textContent.trim()) details.push(location.textContent.trim());
        var customFields = review.querySelector('.jdgm-rev__custom-form');
        var shade = customFields && customFields.textContent.match(/\bShade\s*:?\s*(Soft Brown|Cool Taupe|Rich Brown)\b/i);
        if (shade) details.push('Shade: ' + shade[1]);
        if (review.getAttribute('data-verified-buyer') === 'true') details.push('Verified Buyer');
        if (!details.length) return;
        var footer = document.createElement('div');
        footer.className = 'av-review-details';
        footer.textContent = details.join(' · ');
        content.appendChild(footer);
        review.setAttribute('data-av-review-details', 'true');
      });
    }
    showReviewDetails();
    if ('MutationObserver' in window) {
      var pending;
      new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(showReviewDetails, 100); }).observe(section, { childList: true, subtree: true });
    }
  })();

  document.querySelectorAll('[data-write-review]').forEach(function (b) { b.addEventListener('click', openReviewForm); });
  if (/[?&]open_review=1/.test(location.search) && document.getElementById('judgeme_product_reviews')) setTimeout(openReviewForm, 800);

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw data; return data; }); });
  }

  /* ---------- Cart drawer (Ajax Cart API) ---------- */
  var Cart = {
    backdrop: document.querySelector('[data-cart-backdrop]'),
    drawer: document.querySelector('[data-cart-drawer]'),
    itemsEl: document.querySelector('[data-cart-items]'),
    subtotalEl: document.querySelector('[data-cart-subtotal]'),
    discountRow: document.querySelector('[data-cart-discount-row]'),
    discountEl: document.querySelector('[data-cart-discount]'),
    discountCodesEl: document.querySelector('[data-cart-discount-codes]'),
    countEls: document.querySelectorAll('[data-cart-count]'),
    threshold: Number(cfg.freeShippingThreshold || 0),
    isOpen: false,

    open: function () {
      if (this.backdrop) this.backdrop.classList.add('open');
      if (this.drawer) { this.drawer.classList.add('open'); this.drawer.setAttribute('aria-hidden', 'false'); }
      this.isOpen = true;
      document.body.style.overflow = 'hidden';
      var close = this.drawer && this.drawer.querySelector('[data-cart-close]');
      if (close) close.focus({ preventScroll: true });
    },
    close: function () {
      if (this.backdrop) this.backdrop.classList.remove('open');
      if (this.drawer) { this.drawer.classList.remove('open'); this.drawer.setAttribute('aria-hidden', 'true'); }
      this.isOpen = false;
      document.body.style.overflow = '';
    },
    refresh: function () {
      var self = this;
      return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        self.render(cart);
        document.dispatchEvent(new CustomEvent('aveline:cart', { detail: { cart: cart } }));
        return cart;
      });
    },
    render: function (cart) {
      this.countEls.forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      if (this.subtotalEl) this.subtotalEl.textContent = fmt(cart.total_price);
      if (this.discountRow) {
        var discount = Number(cart.total_discount || 0);
        this.discountRow.hidden = discount <= 0;
        if (this.discountEl) this.discountEl.textContent = '−' + fmt(discount);
        if (this.discountCodesEl) {
          var codes = (cart.cart_level_discount_applications || []).map(function (d) { return d.title; });
          (cart.items || []).forEach(function (item) { (item.line_level_discount_allocations || []).forEach(function (a) { if (a.discount_application && codes.indexOf(a.discount_application.title) === -1) codes.push(a.discount_application.title); }); });
          this.discountCodesEl.textContent = codes.length ? '(' + codes.join(', ') + ')' : '';
        }
      }
      /* Free-shipping progress bars (drawer + cart page). Every [data-cart-progress]
         instance fills toward the threshold and updates its message together. */
      var thresh = this.threshold;
      if (thresh > 0) {
        var met = cart.total_price >= thresh;
        var pct = met ? 100 : Math.min(100, Math.round((cart.total_price / thresh) * 100));
        var remaining = Math.max(0, thresh - cart.total_price);
        document.querySelectorAll('[data-cart-progress]').forEach(function (bar) {
          bar.classList.toggle('ship-bar--met', met);
          var fill = bar.querySelector('[data-cart-progress-fill]');
          var msg = bar.querySelector('[data-cart-progress-msg]');
          if (fill) { fill.style.width = pct + '%'; }
          var track = bar.querySelector('.ship-bar__track');
          if (track) track.setAttribute('aria-valuenow', pct);
          if (msg) msg.textContent = met ? 'You have unlocked free shipping.' : 'You are ' + fmt(remaining) + ' away from free shipping.';
        });
      }
      if (!this.itemsEl) return;
      if (cart.item_count === 0) {
        var st = cfg.strings || {};
        this.itemsEl.innerHTML = '<div class="cart-empty"><span class="cart-empty-text">' + esc(st.cartEmpty || 'Your bag is empty.') + '</span><button type="button" class="btn btn-outline" data-cart-close>' + esc(st.continueShopping || 'Continue Shopping') + '</button></div>';
        return;
      }
      var html = cart.items.map(function (item) {
        var img = item.image ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2')) + '" alt="" width="64" height="64" loading="lazy">' : '<div class="cart-line-img"></div>';
        var discounted = item.final_line_price < item.original_line_price;
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        var discounts = (item.line_level_discount_allocations || []).map(function (a) { return a.discount_application ? a.discount_application.title : ''; }).filter(Boolean);
        return '' +
          '<div class="cart-line" data-line-key="' + esc(item.key) + '">' + img +
            '<div class="cart-line-body">' +
              '<span class="cart-line-title">' + esc(item.product_title) + '</span>' +
              (variant ? '<span class="cart-line-variant">' + esc(variant) + '</span>' : '') +
              (discounts.length ? '<span class="cart-line-discount">' + esc(discounts.join(', ')) + '</span>' : '') +
              '<div class="cart-line-row">' +
                '<div class="cart-line-qty"><button type="button" data-cart-qty="-1" aria-label="Decrease">−</button><span>' + item.quantity + '</span><button type="button" data-cart-qty="1" aria-label="Increase">+</button></div>' +
                '<span class="cart-line-price">' + (discounted ? '<s>' + fmt(item.original_line_price) + '</s>' : '') + fmt(item.final_line_price) + '</span>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="cart-line-remove" aria-label="' + esc((cfg.strings || {}).remove || 'Remove') + '" data-cart-remove><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg></button>' +
          '</div>';
      }).join('');
      this.itemsEl.innerHTML = html;
    },
    changeByKey: function (key, delta, remove) {
      var self = this;
      return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var line = cart.items.find(function (i) { return i.key === key; });
        if (!line) return;
        var newQty = remove ? 0 : Math.max(0, line.quantity + delta);
        return postJSON(root + 'cart/change.js', { id: key, quantity: newQty }).then(function () { return self.refresh(); });
      });
    },
    addItems: function (items) {
      return postJSON(root + 'cart/add.js', { items: items });
    },
    applyDiscount: function (code) {
      return postJSON(root + 'cart/update.js', { discount: code || '' }).catch(function () { /* discount codes are optional; checkout still works */ });
    }
  };
  window.AvelineCart = Cart;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); Cart.open(); Cart.refresh(); }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-backdrop]')) Cart.close();
    var line = e.target.closest('[data-line-key]');
    if (line && Cart.itemsEl && Cart.itemsEl.contains(line)) {
      var qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn) Cart.changeByKey(line.getAttribute('data-line-key'), Number(qtyBtn.getAttribute('data-cart-qty')));
      if (e.target.closest('[data-cart-remove]')) Cart.changeByKey(line.getAttribute('data-line-key'), 0, true);
    }
  });
  if (Cart.drawer) Cart.refresh();

  /* ---------- Header: compact + shadow once scrolled ---------- */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var onHeaderScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 12); };
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  /* ---------- Mobile menu ---------- */
  var menuBackdrop = document.querySelector('[data-menu-backdrop]');
  var menu = document.querySelector('[data-mobile-menu]');
  var menuBtn = document.querySelector('[data-menu-open]');
  function toggleMenu(open) {
    if (!menu) return;
    menu.classList.toggle('open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (menuBackdrop) menuBackdrop.classList.toggle('open', open);
    if (menuBtn) menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) toggleMenu(true);
    if (e.target.closest('[data-menu-close]') || e.target.closest('[data-menu-backdrop]')) toggleMenu(false);
  });

  /* ---------- Marquee: speed derived from measured width (55px/s), as in the design ---------- */
  document.querySelectorAll('[data-marquee-track]').forEach(function (track) {
    if (reducedMotion) return;
    function measure() {
      var half = track.scrollWidth / 2;
      var speed = Number(track.getAttribute('data-marquee-speed')) || 55;
      track.style.animationDuration = Math.max(15, half / speed) + 's';
    }
    window.addEventListener('resize', measure);
    setTimeout(measure, 60);
  });

  /* ---------- Reveal on scroll ---------- */
  if (!reducedMotion && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('reveal-in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    setTimeout(function () { document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); }); }, 150);
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('reveal-in'); });
  }

  /* ---------- Accordions (product info, FAQ, help centre) ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;
    var item = trigger.closest('.accordion-item');
    var group = trigger.getAttribute('data-accordion-group');
    var singleOpen = trigger.getAttribute('data-accordion-single') === 'true';
    var willOpen = !item.classList.contains('open');
    if (singleOpen && group) {
      document.querySelectorAll('.accordion-item[data-accordion-group="' + group + '"]').forEach(function (other) {
        if (other !== item) { other.classList.remove('open'); var t = other.querySelector('[data-accordion-trigger]'); if (t) t.setAttribute('aria-expanded', 'false'); }
      });
    }
    item.classList.toggle('open', willOpen);
    trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  });
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (t) {
    var item = t.closest('.accordion-item');
    t.setAttribute('aria-expanded', item && item.classList.contains('open') ? 'true' : 'false');
  });

  /* ---------- Video modal (UGC cards, "watch how easy it is") ---------- */
  var videoBackdrop = document.querySelector('[data-video-modal]');
  var videoLabel = document.querySelector('[data-video-label]');
  var modalVideoPlayer = document.querySelector('[data-video-player]');
  var videoBox = videoBackdrop ? videoBackdrop.querySelector('.video-modal-box') : null;
  function embedSrc(type, id) {
    if (type === 'youtube') return 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&mute=1&loop=1&controls=0&rel=0&playsinline=1&playlist=' + encodeURIComponent(id);
    if (type === 'vimeo') return 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1&muted=1&loop=1&background=1';
    return '';
  }
  function openVideo(trigger) {
    if (!videoBackdrop) return;
    var label = trigger.getAttribute('data-play-video') || 'Now Playing';
    var type = trigger.getAttribute('data-video-type');
    var id = trigger.getAttribute('data-video-id');
    var mp4 = trigger.getAttribute('data-video-src');
    if (videoLabel) videoLabel.textContent = label;
    if (modalVideoPlayer) {
      modalVideoPlayer.innerHTML = '';
      var src = embedSrc(type, id);
      if (src) modalVideoPlayer.innerHTML = '<iframe src="' + esc(src) + '" title="' + esc(label) + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
      else if (mp4) modalVideoPlayer.innerHTML = '<video src="' + esc(mp4) + '" data-inline-video autoplay muted loop playsinline preload="auto"></video>';
      if (videoBox) videoBox.classList.toggle('has-video', !!(src || mp4));
    }
    videoBackdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeVideo() {
    if (!videoBackdrop || !videoBackdrop.classList.contains('open')) return;
    videoBackdrop.classList.remove('open');
    if (modalVideoPlayer) modalVideoPlayer.innerHTML = '';
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-play-video]');
    if (trigger) { openVideo(trigger); return; }
    if (e.target.closest('[data-video-close]') || e.target === videoBackdrop) closeVideo();
  });

  /* ---------- Inline videos: native muted, continuous autoplay ---------- */
  var ivInit = new WeakSet();
  function ivPlayNow(v) {
    if (!v.paused) return;
    try {
      var play = v.play();
      if (play && play.catch) play.catch(function () { v.dataset.autoplayBlocked = '1'; });
    } catch (e) { v.dataset.autoplayBlocked = '1'; }
  }
  function initInlineVideos() {
    document.querySelectorAll('video').forEach(function (v) {
      if (ivInit.has(v)) return;
      ivInit.add(v);
      v.setAttribute('data-inline-video', '');
      v.muted = true; v.defaultMuted = true; v.autoplay = true;
      v.loop = true; v.playsInline = true; v.controls = false; v.preload = v.getAttribute('preload') || 'metadata';
      v.setAttribute('disablepictureinpicture', '');
      v.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
      v.addEventListener('canplay', function () { ivPlayNow(v); });
      v.addEventListener('loadeddata', function () { ivPlayNow(v); });
      v.addEventListener('playing', function () { delete v.dataset.autoplayBlocked; });
      ivPlayNow(v);
    });
  }
  function resumeInlineVideos() {
    if (!document.hidden) document.querySelectorAll('video').forEach(ivPlayNow);
  }
  initInlineVideos();
  document.addEventListener('shopify:section:load', initInlineVideos);
  document.addEventListener('visibilitychange', resumeInlineVideos);
  window.addEventListener('pageshow', resumeInlineVideos);
  /* A real gesture permits a retry when a browser initially blocks autoplay. */
  document.addEventListener('pointerdown', resumeInlineVideos, { passive: true });
  document.addEventListener('keydown', resumeInlineVideos);
  if ('MutationObserver' in window) {
    var ivTimer;
    new MutationObserver(function () {
      clearTimeout(ivTimer); ivTimer = setTimeout(initInlineVideos, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Before / after slider ---------- */
  document.querySelectorAll('[data-compare-slider]').forEach(function (slider) {
    var beforeWrap = slider.querySelector('[data-compare-before-wrap]');
    var divider = slider.querySelector('[data-compare-divider]');
    var range = slider.querySelector('input[type="range"]');
    if (!beforeWrap || !divider || !range) return;
    function setPct(pct) {
      pct = Math.max(0, Math.min(100, pct));
      beforeWrap.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      divider.style.left = pct + '%';
    }
    function apply(pct) { setPct(pct); range.value = pct; }
    apply(Number(range.value));
    /* Keyboard / assistive tech still drive it through the range input. */
    range.addEventListener('input', function () { setPct(Number(range.value)); });
    /* Pointer drag from anywhere on the image (mouse, touch and pen). The native
       range alone can't do this on mobile: iOS only moves a range when the drag
       starts on the thumb, which is invisible here, so touching the image did
       nothing. Pointer events + a touch-action of pan-y (set in CSS) let a
       horizontal drag compare while a vertical swipe still scrolls the page. */
    if (window.PointerEvent) {
      var dragging = false;
      function pctFromEvent(e) {
        var rect = slider.getBoundingClientRect();
        return rect.width ? ((e.clientX - rect.left) / rect.width) * 100 : 0;
      }
      slider.addEventListener('pointerdown', function (e) {
        dragging = true;
        if (slider.setPointerCapture) { try { slider.setPointerCapture(e.pointerId); } catch (err) { /* older engines */ } }
        apply(pctFromEvent(e));
      });
      slider.addEventListener('pointermove', function (e) {
        if (dragging) apply(pctFromEvent(e));
      });
      function endDrag() { dragging = false; }
      slider.addEventListener('pointerup', endDrag);
      slider.addEventListener('pointercancel', endDrag);
    }
  });

  /* ---------- Find your fit: selectable looks + outcome card ---------- */
  document.querySelectorAll('[data-fit-section]').forEach(function (section) {
    var cards = section.querySelectorAll('[data-fit-card]');
    /* Scope to the outcome panel: the cards carry the same data attributes,
       so an unscoped lookup would grab the first card and overwrite it. */
    var outcome = section.querySelector('.fit-outcome');
    var name = outcome ? outcome.querySelector('[data-fit-name]') : null;
    var desc = outcome ? outcome.querySelector('[data-fit-desc]') : null;
    var img = outcome ? outcome.querySelector('img[data-fit-image]') : null;
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (c) { c.classList.toggle('selected', c === card); c.setAttribute('aria-pressed', c === card ? 'true' : 'false'); });
        if (name) name.textContent = card.getAttribute('data-fit-name');
        if (desc) desc.textContent = card.getAttribute('data-fit-desc');
        var src = card.getAttribute('data-fit-image');
        if (src) {
          if (!img) {
            var ph = outcome ? outcome.querySelector('[data-fit-placeholder]') : null;
            if (ph) { img = document.createElement('img'); img.setAttribute('data-fit-image', ''); img.width = 220; img.height = 180; img.alt = ''; ph.replaceWith(img); }
          }
          if (img) { img.src = src; img.hidden = false; }
        }
      });
    });
  });

  /* ---------- Reviews filter + load more ---------- */
  (function () {
    var reviewCards = Array.prototype.slice.call(document.querySelectorAll('[data-review-card]'));
    if (!reviewCards.length) return;
    var reviewsShown = 4, activeFilter = 'all';
    var loadMoreBtn = document.querySelector('[data-reviews-load-more]');
    function renderReviews() {
      var filtered = reviewCards.filter(function (c) {
        var tags = (c.getAttribute('data-tags') || '').split(',').map(function (t) { return t.trim().toLowerCase(); });
        return activeFilter === 'all' || tags.indexOf(activeFilter) !== -1;
      });
      reviewCards.forEach(function (c) { c.hidden = true; });
      filtered.forEach(function (c, i) { c.hidden = i >= reviewsShown; });
      if (loadMoreBtn) loadMoreBtn.hidden = filtered.length <= reviewsShown;
    }
    document.querySelectorAll('[data-review-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('[data-review-filter]').forEach(function (b) { b.classList.remove('selected'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('selected'); btn.setAttribute('aria-pressed', 'true');
        activeFilter = btn.getAttribute('data-review-filter');
        reviewsShown = 4;
        renderReviews();
      });
    });
    if (loadMoreBtn) loadMoreBtn.addEventListener('click', function () { reviewsShown += 4; renderReviews(); });
    renderReviews();
  })();

  /* ---------- Escape closes overlays ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeVideo();
    var exit = document.querySelector('[data-exit-modal].open');
    if (exit) { exit.classList.remove('open'); document.body.style.overflow = ''; }
    if (Cart.isOpen) Cart.close();
    toggleMenu(false);
  });

  /* ================= Product page ================= */
  var pdp = document.querySelector('[data-product-root]');
  if (pdp) initProductPage(pdp);

  function initProductPage(root) {
    var dataEl = document.getElementById('product-json');
    if (!dataEl) return;
    var productData = JSON.parse(dataEl.textContent);
    var variants = productData.variants;
    var options = productData.options_with_values;
    var strings = {};
    Object.keys(cfg.strings || {}).forEach(function (k) { strings[k] = decodeEntities(cfg.strings[k]); });

    /* Gallery: thumbnails, arrows, dots, swipe */
    var galleryImg = root.querySelector('[data-gallery-image]');
    var galleryCounter = root.querySelector('[data-gallery-counter]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    /* Variant packshots can be excluded from the strip and arrows but stay
       addressable for shade/shape swaps (data-variant-only, hidden in Liquid). */
    var navThumbs = thumbs.filter(function (t) { return !t.hasAttribute('data-variant-only'); });
    if (!navThumbs.length) navThumbs = thumbs;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-dot]'));
    var activeIndex = 0;
    function setMainImage(thumb) {
      if (galleryImg) { galleryImg.src = thumb.getAttribute('data-full-src'); galleryImg.alt = thumb.getAttribute('data-alt') || ''; }
    }
    function showImage(i) {
      if (!navThumbs.length) return;
      activeIndex = (i + navThumbs.length) % navThumbs.length;
      var thumb = navThumbs[activeIndex];
      setMainImage(thumb);
      if (galleryCounter) galleryCounter.textContent = (activeIndex + 1) + ' / ' + navThumbs.length;
      navThumbs.forEach(function (t, idx) { t.classList.toggle('active', idx === activeIndex); t.setAttribute('aria-current', idx === activeIndex ? 'true' : 'false'); });
      dots.forEach(function (d, idx) { d.classList.toggle('active', idx === activeIndex); });
    }
    navThumbs.forEach(function (t, idx) { t.addEventListener('click', function () { showImage(idx); }); });
    root.querySelectorAll('[data-gallery-prev]').forEach(function (b) { b.addEventListener('click', function () { showImage(activeIndex - 1); }); });
    root.querySelectorAll('[data-gallery-next]').forEach(function (b) { b.addEventListener('click', function () { showImage(activeIndex + 1); }); });
    var touchStartX = null;
    var frame = root.querySelector('[data-gallery-frame]');
    if (frame) {
      frame.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
      frame.addEventListener('touchend', function (e) {
        if (touchStartX == null) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (dx > 40) showImage(activeIndex - 1); else if (dx < -40) showImage(activeIndex + 1);
        touchStartX = null;
      });
    }
    function showThumb(thumb) {
      var navIdx = navThumbs.indexOf(thumb);
      if (navIdx >= 0) { showImage(navIdx); return; }
      /* Hidden variant packshot: swap the hero image without touching the strip. */
      setMainImage(thumb);
      navThumbs.forEach(function (t) { t.classList.remove('active'); t.setAttribute('aria-current', 'false'); });
    }
    function showVariantImage(v, selections) {
      if (!v) return;
      /* Thumbs carry media ids; product JSON exposes them as featured_media.id
         (featured_image.id is the image id, which never matches). */
      var mediaId = (v.featured_media && v.featured_media.id) || (v.featured_image && v.featured_image.id);
      if (mediaId) {
        var thumb = thumbs.find(function (t) { return Number(t.getAttribute('data-media-id')) === mediaId; });
        if (thumb) { showThumb(thumb); return; }
      }
      /* No image pinned to the variant: match media whose alt text names the selected options
         (set each image's alt to e.g. "Soft Brown Curved" in Shopify admin to wire this up). */
      var sels = (selections || currentMainSelections()).map(function (s) { return String(s).toLowerCase(); });
      var byAlt = thumbs.find(function (t) {
        var a = (t.getAttribute('data-alt') || '').toLowerCase();
        return a && sels.every(function (s) { return a.indexOf(s) !== -1; });
      });
      if (byAlt) showThumb(byAlt);
    }

    /* Variant resolution */
    function findVariant(selections) {
      return variants.find(function (v) { return v.options.every(function (val, i) { return val === selections[i]; }); });
    }
    function currentMainSelections() {
      var slot = null;
      var t = tierFor(qty);
      if (t) slot = t.el.querySelector('[data-kit-slot="0"]');
      if (!slot) slot = root.querySelector('[data-kit-slot="0"]');
      if (slot) {
        return options.map(function (opt, oi) {
          var el = slot.querySelector('[data-kit-slot-option="' + oi + '"]');
          return el ? el.value : opt.values[0];
        });
      }
      return options.map(function (opt, i) {
        var el = root.querySelector('[data-option-swatch][data-option-index="' + i + '"].selected');
        return el ? el.getAttribute('data-value') : opt.values[0];
      });
    }
    function currentVariant() { return findVariant(currentMainSelections()) || variants[0]; }

    root.querySelectorAll('[data-option-swatch]').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var i = swatch.getAttribute('data-option-index');
        var value = swatch.getAttribute('data-value');
        root.querySelectorAll('[data-option-swatch][data-option-index="' + i + '"]').forEach(function (s) {
          var on = s.getAttribute('data-value') === value;
          s.classList.toggle('selected', on);
          s.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-option-name="' + i + '"]').forEach(function (n) { n.textContent = value; });
        var v = currentVariant();
        showVariantImage(v);
        refreshPricing();
      });
    });

    /* Packshot for a shade + shape combination: the variant's pinned image, or a
       gallery image whose alt names both values, or the current hero as a fallback. */
    function sized(src, w) { return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
    function packshotFor(sel) {
      var v = findVariant(sel);
      if (v && v.featured_image && v.featured_image.src) return sized(v.featured_image.src, 160);
      var sl = sel.map(function (x) { return String(x).toLowerCase(); });
      var byAlt = thumbs.find(function (t) {
        var a = (t.getAttribute('data-alt') || '').toLowerCase();
        return a && sl.every(function (x) { return a.indexOf(x) !== -1; });
      });
      if (byAlt) return byAlt.getAttribute('data-full-src');
      return galleryImg ? galleryImg.src : '';
    }
    function refreshSlotThumbs(slots) {
      Array.prototype.forEach.call(slots.querySelectorAll('[data-kit-slot]'), function (slot) {
        var img = slot.querySelector('[data-kit-slot-img]');
        if (!img) return;
        var sel = options.map(function (opt, oi) { var el = slot.querySelector('[data-kit-slot-option="' + oi + '"]'); return el ? el.value : opt.values[0]; });
        var src = packshotFor(sel);
        if (img.getAttribute('src') !== src) {
          img.src = src;
          if (!reducedMotion) { img.classList.remove('swap'); void img.offsetWidth; img.classList.add('swap'); }
        }
      });
    }

    /* Bundle tiers, priced from the live variant + the store's real discount rules */
    var bundleCards = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-card]'));
    var qtyDisplay = root.querySelector('[data-qty-value]');
    var qty = 1;
    function tierOf(card) {
      return {
        el: card,
        units: Math.max(1, Number(card.getAttribute('data-units')) || 1),
        rule: card.getAttribute('data-rule') || 'none',
        customCents: Number(card.getAttribute('data-custom-cents')) || 0,
        code: card.getAttribute('data-code') || ''
      };
    }
    function tierFor(q) {
      var best = null;
      bundleCards.forEach(function (c) {
        var units = Number(c.getAttribute('data-units'));
        if (q >= units && (!best || units >= Number(best.getAttribute('data-units')))) best = c;
      });
      return best ? tierOf(best) : null;
    }
    /* Total the customer will actually pay for `q` kits under a tier rule. */
    function totalFor(tier, q, unit) {
      if (!tier) return unit * q;
      switch (tier.rule) {
        case 'second_half': return Math.round(unit * q - Math.floor(q / 2) * unit * 0.5);
        case 'third_free': return unit * (q - Math.floor(q / 3));
        case 'custom': return tier.customCents ? Math.round(tier.customCents * (q / tier.units)) : unit * q;
        default: return unit * q;
      }
    }
    function compareFor(tier, q, unit, compareUnit) {
      var base = compareUnit > unit ? compareUnit : unit;
      var total = totalFor(tier, q, unit);
      var comp = base * q;
      return comp > total ? comp : 0;
    }
    function selectBundle(card) {
      bundleCards.forEach(function (c) { c.classList.toggle('selected', c === card); });
      qty = Number(card.getAttribute('data-units')) || 1;
      if (qtyDisplay) qtyDisplay.textContent = qty;
      renderKitSlots();
      pulseAddButton();
      refreshPricing();
    }
    bundleCards.forEach(function (card) {
      var btn = card.querySelector('[data-bundle-select]');
      if (btn) btn.addEventListener('click', function () { selectBundle(card); });
      var slots = card.querySelector('[data-kit-slots]');
      if (slots) {
        slots.addEventListener('click', function (e) { e.stopPropagation(); });
        slots.addEventListener('change', function (e) {
          if (!e.target.hasAttribute('data-kit-slot-option')) return;
          refreshSlotThumbs(slots);
          var selections = readKitSlots(slots);
          if (selections.length) showVariantImage(findVariant(selections[0]), selections[0]);
          refreshPricing();
        });
      }
    });

    /* Per-kit shade/shape selectors (multi-kit tiers), pre-filled from the main selection */
    function renderKitSlots() {
      var t = tierFor(qty);
      var mainSelections = currentMainSelections();
      bundleCards.forEach(function (card) {
        var slots = card.querySelector('[data-kit-slots]');
        if (!slots) return;
        var isCurrent = t && t.el === card;
        var units = Number(card.getAttribute('data-units'));
        if (!isCurrent) { slots.innerHTML = ''; return; }
        var existing = readKitSlots(slots);
        var html = '';
        for (var i = 0; i < units; i++) {
          html += '<div class="kit-slot" data-kit-slot="' + i + '">';
          html += '<span class="kit-slot-thumb"><img data-kit-slot-img src="" alt="" width="92" height="92" loading="lazy"></span>';
          html += '<div class="kit-slot-main">';
          if (units > 1) html += '<span class="kit-slot-label">Kit ' + (i + 1) + '</span>';
          html += '<div class="kit-slot-fields">';
          options.forEach(function (opt, oi) {
            var current = existing[i] ? existing[i][oi] : mainSelections[oi];
            html += '<select data-kit-slot-option="' + oi + '" aria-label="Kit ' + (i + 1) + ' ' + esc(opt.name) + '">';
            opt.values.forEach(function (val) { html += '<option value="' + esc(val) + '"' + (val === current ? ' selected' : '') + '>' + esc(val) + '</option>'; });
            html += '</select>';
          });
          html += '</div></div></div>';
        }
        slots.innerHTML = html;
        refreshSlotThumbs(slots);
      });
      placeProtection();
    }
    /* Shipping protection lives inside the selected tier card (one row, moved between cards) */
    function placeProtection() {
      var row = root.querySelector('[data-protection-row]');
      var t = tierFor(qty);
      var slot = t && t.el.querySelector('[data-protection-slot]');
      if (row && slot && row.parentNode !== slot) slot.appendChild(row);
    }
    function readKitSlots(slots) {
      return Array.prototype.map.call(slots.querySelectorAll('[data-kit-slot]'), function (slot) {
        return options.map(function (opt, oi) { var el = slot.querySelector('[data-kit-slot-option="' + oi + '"]'); return el ? el.value : opt.values[0]; });
      });
    }

    /* Quantity stepper: quantity is the single source of truth for the tier + price */
    root.querySelectorAll('[data-qty-dec]').forEach(function (b) { b.addEventListener('click', function () { setQty(qty - 1); }); });
    root.querySelectorAll('[data-qty-inc]').forEach(function (b) { b.addEventListener('click', function () { setQty(qty + 1); }); });
    function setQty(q) {
      qty = Math.max(1, q);
      if (qtyDisplay) qtyDisplay.textContent = qty;
      var t = tierFor(qty);
      bundleCards.forEach(function (c) { c.classList.toggle('selected', t && t.el === c); });
      renderKitSlots();
      pulseAddButton();
      refreshPricing();
    }

    /* Shipping protection add-on (a real product variant, configured in the theme editor) */
    var protectionCheckbox = root.querySelector('[data-protection-checkbox]');
    var protectionVariantId = Number(root.getAttribute('data-protection-variant-id')) || 0;
    var protectionCents = Number(root.getAttribute('data-protection-price')) || 0;
    if (protectionCheckbox) protectionCheckbox.addEventListener('change', refreshPricing);

    var addBtn = root.querySelector('[data-add-to-bag]');
    var addLabel = root.querySelector('[data-add-to-bag-label]');
    var statusEl = root.querySelector('[data-add-status]');
    var stickyBtn = document.querySelector('[data-sticky-add]');
    function pulseAddButton() {
      if (!addBtn || reducedMotion) return;
      addBtn.classList.remove('pulse'); void addBtn.offsetWidth; addBtn.classList.add('pulse');
      setTimeout(function () { addBtn.classList.remove('pulse'); }, 450);
    }
    function refreshPricing() {
      var v = currentVariant();
      var unit = v ? v.price : 0;
      var compareUnit = v && v.compare_at_price ? v.compare_at_price : 0;
      var available = !v || v.available;
      root.querySelectorAll('[data-selected-price]').forEach(function (el) { el.textContent = fmt(unit); });
      root.querySelectorAll('[data-selected-compare]').forEach(function (el) {
        var show = compareUnit > unit;
        el.hidden = !show;
        if (show) el.textContent = fmt(compareUnit);
      });
      bundleCards.forEach(function (card) {
        var t = tierOf(card);
        var total = totalFor(t, t.units, unit);
        var compare = compareFor(t, t.units, unit, compareUnit);
        var priceEl = card.querySelector('[data-tier-price]');
        var compareEl = card.querySelector('[data-tier-compare]');
        if (priceEl) priceEl.textContent = fmt(total);
        if (compareEl) { compareEl.hidden = compare <= 0; compareEl.textContent = fmt(compare); }
        Array.prototype.forEach.call(card.querySelectorAll('[data-tier-savings]'), function (savingsEl) {
          savingsEl.hidden = compare <= 0; savingsEl.textContent = 'Save ' + fmt(compare - total);
        });
      });
      var t = tierFor(qty);
      var lineTotal = totalFor(t, qty, unit) + (protectionCheckbox && protectionCheckbox.checked ? protectionCents : 0);
      var savingsNote = root.querySelector('[data-savings-note]');
      if (savingsNote) {
        var cmpTotal = compareFor(t, qty, unit, compareUnit);
        var saved = cmpTotal > 0 ? cmpTotal - totalFor(t, qty, unit) : 0;
        savingsNote.hidden = saved <= 0;
        var savingsText = savingsNote.querySelector('[data-savings-note-text]') || savingsNote;
        if (saved > 0) savingsText.textContent = (strings.savingNote || "You're saving [amount] on this order").replace('[amount]', fmt(saved));
      }
      var perKit = t ? Math.round(totalFor(t, t.units, unit) / t.units) : unit;
      root.querySelectorAll('[data-unit-price]').forEach(function (el) { el.textContent = fmt(perKit); });
      if (addLabel) addLabel.textContent = (available ? (strings.addToBag || 'Add to Bag') : (strings.soldOut || 'Sold Out')) + ' · ' + fmt(lineTotal);
      if (addBtn) addBtn.disabled = !available || adding;
      if (stickyBtn) stickyBtn.disabled = !available || adding;
    }

    /* Add to bag: one line per distinct kit configuration, then apply the tier's discount code */
    var adding = false;
    function addToBag() {
      if (adding) return;
      adding = true;
      refreshPricing();
      if (statusEl) statusEl.textContent = strings.adding || 'Adding…';
      if (addLabel) addLabel.textContent = strings.adding || 'Adding…';
      pulseAddButton();
      setTimeout(function () {
        var t = tierFor(qty);
        var counts = {};
        var mainV = currentVariant();
        if (t && t.el.querySelector('[data-kit-slot]')) {
          var slotSelections = readKitSlots(t.el.querySelector('[data-kit-slots]'));
          var extra = qty - slotSelections.length;
          slotSelections.forEach(function (sel) { var v = findVariant(sel); if (v) counts[v.id] = (counts[v.id] || 0) + 1; });
          if (extra > 0 && mainV) counts[mainV.id] = (counts[mainV.id] || 0) + extra;
        } else if (mainV) {
          counts[mainV.id] = qty;
        }
        var items = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
        if (protectionCheckbox && protectionCheckbox.checked && protectionVariantId) items.push({ id: protectionVariantId, quantity: 1 });
        if (!items.length) { adding = false; refreshPricing(); return; }
        Cart.addItems(items)
          .then(function () { return (t && t.code) ? Cart.applyDiscount(t.code) : null; })
          .then(function () { return Cart.refresh(); })
          .then(function () {
            Cart.open();
            qty = 1;
            if (qtyDisplay) qtyDisplay.textContent = 1;
            bundleCards.forEach(function (c, i) { c.classList.toggle('selected', i === 0); });
            renderKitSlots();
            if (statusEl) statusEl.textContent = '';
          })
          .catch(function (err) {
            if (statusEl) statusEl.textContent = (err && (err.description || err.message)) || strings.unavailable || 'Sorry, that combination is currently unavailable.';
          })
          .finally(function () { adding = false; refreshPricing(); });
      }, 380);
    }
    if (addBtn) addBtn.addEventListener('click', addToBag);
    if (stickyBtn) stickyBtn.addEventListener('click', addToBag);

    var countdownEls = Array.prototype.slice.call(root.querySelectorAll('[data-promo-countdown]'));
    if (countdownEls.length) {
      var key = 'aveline_promo_deadline_15m_v2';
      var duration = 15 * 60 * 1000;
      var deadline = 0;
      try { deadline = Number(localStorage.getItem(key)); } catch (e) {}
      if (!Number.isFinite(deadline) || deadline <= Date.now() || deadline > Date.now() + duration) {
        deadline = Date.now() + duration;
        try { localStorage.setItem(key, String(deadline)); } catch (e) {}
      }
      var tick = function () {
        var rem = Math.max(0, deadline - Date.now());
        var seconds = Math.ceil(rem / 1000);
        var h = String(Math.floor(seconds / 3600)).padStart(2, '0');
        var m = String(Math.floor(seconds / 60) % 60).padStart(2, '0');
        var s = String(seconds % 60).padStart(2, '0');
        countdownEls.forEach(function (el) {
          if (!el.querySelector('.countdown-number')) el.innerHTML = '<span class="countdown-number">' + h + '</span>H <span class="countdown-number">' + m + '</span>M <span class="countdown-number">' + s + '</span>S';
          var digits = el.querySelectorAll('.countdown-number');
          [h, m, s].forEach(function (value, index) { digits[index].textContent = value; });
          el.classList.toggle('urgent', rem > 0 && rem <= 120000);
        });
        if (!rem) clearInterval(promoInterval);
      };
      var promoInterval = setInterval(tick, 1000);
      tick();
    }

    /* "Ships by" date (lead days configurable in the theme editor) */
    var shipsBy = root.querySelector('[data-ships-by]');
    if (shipsBy) {
      var lead = Number(shipsBy.getAttribute('data-lead-days')) || 3;
      var d = new Date(); d.setDate(d.getDate() + lead);
      var day = d.getDate();
      var suffix = (day % 10 === 1 && day !== 11) ? 'st' : (day % 10 === 2 && day !== 12) ? 'nd' : (day % 10 === 3 && day !== 13) ? 'rd' : 'th';
      shipsBy.textContent = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getDay()] + ', ' + day + suffix + ' ' + ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][d.getMonth()];
    }

    /* Sticky mobile add bar: after the buy box scrolls out of view */
    var stickyBar = document.querySelector('[data-sticky-bar]');
    var buybox = root.querySelector('[data-buybox]');
    if (stickyBar && buybox) {
      var onScroll = function () { stickyBar.classList.toggle('visible', buybox.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* Exit-intent popup: once per session, only after scrolling, never over another overlay */
    var exitModal = document.querySelector('[data-exit-modal]');
    var exitShown = false;
    try { exitShown = sessionStorage.getItem('aveline_exit_shown') === '1'; } catch (e) {}
    if (exitModal && !exitShown) {
      var onMouseOut = function (e) {
        if (e.clientY > 40 || window.scrollY < 200) return;
        if (Cart.isOpen || (menu && menu.classList.contains('open')) || (videoBackdrop && videoBackdrop.classList.contains('open'))) return;
        try { sessionStorage.setItem('aveline_exit_shown', '1'); } catch (e) {}
        exitModal.classList.add('open');
        document.body.style.overflow = 'hidden';
        var input = exitModal.querySelector('input[type="email"]');
        if (input) input.focus({ preventScroll: true });
        document.removeEventListener('mouseout', onMouseOut);
      };
      document.addEventListener('mouseout', onMouseOut);
    }
    document.addEventListener('click', function (e) {
      if (exitModal && (e.target.closest('[data-exit-close]') || e.target === exitModal)) { exitModal.classList.remove('open'); document.body.style.overflow = ''; }
    });
    /* Shopify redirects back to #exit-newsletter after a successful signup; reopen the
       popup so the server-rendered success message (and any code) is visible. */
    if (exitModal && window.location.hash === '#exit-newsletter' && exitModal.querySelector('[data-exit-success]')) {
      try { sessionStorage.setItem('aveline_exit_shown', '1'); } catch (e) {}
      exitModal.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    setQty(1);
    showImage(0);
    refreshPricing();
  }

  /* ================= Cart page ================= */
  var cartPage = document.querySelector('[data-cart-page]');
  if (cartPage) {
    cartPage.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line-key]');
      if (!line) return;
      var qtyBtn = e.target.closest('[data-cart-qty]');
      var remove = e.target.closest('[data-cart-remove]');
      if (!qtyBtn && !remove) return;
      e.preventDefault();
      Cart.changeByKey(line.getAttribute('data-line-key'), qtyBtn ? Number(qtyBtn.getAttribute('data-cart-qty')) : 0, !!remove).then(function () { window.location.reload(); });
    });
    var discountForm = cartPage.querySelector('[data-cart-discount-form]');
    if (discountForm) {
      discountForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var code = discountForm.querySelector('input').value.trim();
        if (!code) return;
        Cart.applyDiscount(code).then(function () { window.location.reload(); });
      });
    }
  }
})();

